import { useEffect, useRef, useState } from 'react'
import { BasketIcon } from '../icons'

// The phone's docked basket bar (ux/03 BasketBar): the highest-contrast thing
// on screen and the only place the basket fraction appears. Ticks to 1.03
// for 160 ms each time something lands, no bounce. Opens the basket sheet.
export function BasketBar({ inBasket, total, last, onOpen }: {
  inBasket: number
  total: number
  last: string | null
  onOpen: () => void
}) {
  const [tick, setTick] = useState(0)
  const prev = useRef(inBasket)
  useEffect(() => {
    if (inBasket > prev.current) setTick(t => t + 1)
    prev.current = inBasket
  }, [inBasket])

  return (
    <button type="button" key={tick} className={`ml-basket-bar${tick ? ' is-ticking' : ''}`} onClick={onOpen}
      aria-label={`Basket, ${inBasket} of ${total}${last ? `, last ${last}` : ''}`}>
      <BasketIcon size={20} />
      <span className="ml-label ml-basket-bar__label">Basket</span>
      <span className="ml-basket-bar__last">{last ? `Last: ${last}` : ''}</span>
      <span className="ml-basket-bar__count ml-num">
        <span className="ml-basket-bar__n">{inBasket}</span>
        <span className="ml-basket-bar__total">/{total}</span>
      </span>
    </button>
  )
}
